const cookieNames = {};

cookieNames.jwt = 'jwt';
cookieNames.lastReferrerUrl = 'lastReferrerUrl';

export default cookieNames;